import React from "react";
import { observer } from "mobx-react";
import { BotStepViewStore } from "../../store";
import { BotStepViewForm } from "./BotStepViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type BotStepViewProps = {
  botStepViewStore: BotStepViewStore;
};

export const BotStepView: React.FC<BotStepViewProps> = observer(
  ({ botStepViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <BotStepViewForm
          stepNumber={botStepViewStore.stepNumberValue}
          stepId={botStepViewStore.stepIdValue}
          status={botStepViewStore.statusValue}
          startedAt={botStepViewStore.startedAtValue}
          completedAt={botStepViewStore.completedAtValue}
          duration={botStepViewStore.durationValue}
          error={botStepViewStore.errorValue}
          downloadedFileFiles={botStepViewStore.downloadedFileFiles}
          onPrint={(handlePrint: () => void) =>
            botStepViewStore.printBotStep(handlePrint)
          }
          onCancel={() => botStepViewStore.cancelBotStep()}
          onEdit={
            botStepViewStore.isEditEnabled
              ? () => botStepViewStore.editBotStep()
              : undefined
          }
          downloadedFileViewAction={getViewAction(
            (props) => botStepViewStore.fileDownload(props, "downloadedFile"),
            (props) => botStepViewStore.viewFilePdf(props, "downloadedFile")
          )}
        />
        <ErrorDialog
          open={botStepViewStore.errorDialogOpened}
          title={botStepViewStore.errorTitle}
          description={botStepViewStore.errorDescription}
          onClose={() => botStepViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={botStepViewStore.pdfViewerOpen}
          onClose={() => botStepViewStore.closePdfViewer()}
          pdfUrl={botStepViewStore.pdfViewerUrl}
          title={botStepViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
